import styled from 'styled-components';

export const Container = styled.div`
  outline: none !important;
  .rbc-event {
    height: 20px;
    border-radius: 2px;
    background-color: ${(props) => props.color} !important;
    padding: 2px 8px 3px;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    text-align: center;
    color: #fff;
    letter-spacing: normal;
    outline: none !important;
    .rbc-event-content {
      pointer-events: none;
    }
  }
`;
